(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('manage-bbps-settings', {
                parent: 'entity',
                url: '/manage-bbps-settings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                ncyBreadcrumb: {
                    label: '{{ "global.menu.manageBBPSSetting.main" | translate }}',
                    parent: 'home'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings.html',
                        controller: 'ManageBBPSSettingsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');

                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }
            })

            .state('bbps-settings-view', {
                parent: 'manage-bbps-settings',
                url: '/manage-bbps-settings/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {

                            entity: ['BBPSSettings', 'GlobalValues', function (BBPSSettings, GlobalValues) {
                                return BBPSSettings.get({ id: $stateParams.id }).$promise;
                            }]

                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })
            .state('bbps-settings-edit', {
                parent: 'manage-bbps-settings',
                url: '/edit/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-dialog.html',
                        controller: 'BBPSSettingsEditController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {

                            entity: ['BBPSSettings', 'GlobalValues', function (BBPSSettings, GlobalValues) {
                                return BBPSSettings.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })
            .state('bbps-settings-todolist', {
                parent: 'dashboard',
                url: '/BBPSSettings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })
            .state('bbps-settings-todolist.resubmit', {
                parent: 'dashboard',
                url: '/BBPSSettingsEdit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-dialog.html',
                        controller: 'BBPSSettingsEditController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {

                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('bbps-settings-auditLog', {
                parent: 'audit-log',
                url: '/BBPSSettingsAuditLog',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/manage-bbps-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }

            })

            .state('bbps-settings-historyReport', {
                parent: 'history-report',
                url: '/BBPSSettingsHistoryReport',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/markup-settings/manage-bbps-settings-details.html',
                        controller: 'BBPSSettingsViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('manage-bbps-settings', null, { reload: 'manage-bbps-settings' });
                    }, function () {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('manageBBPSSettings');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    };
})();
